import { Injectable } from '@angular/core';

import { Reminder } from '../../models/reminder';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class ReminderService extends BackendBaseService {
  url: string = 'reminders';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  activate(reminder_id: number): Promise<any> {
    return this.httpClient.put(`${this.url}/${reminder_id}.json`, { activate: true });
  }

  dismiss(reminder_id: number): Promise<any> {
    return this.httpClient.post(`${this.url}/${reminder_id}/dismiss.json`, {});
  }

  formOptions2(params: any = {}): Promise<any> {
    params.form_options_2 = true;
    return this.httpClient.get(`${this.url}.json`, params);
  }

  index(params: any = { angular: '4', filter: 'current', order: 'priority' }): Promise<Array<Reminder>> {
    return this.httpClient.get(`${this.url}.json`, params).then((response) => response as Array<Reminder>);
  }

  index2(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params).then((response) => response as Array<Reminder>);
  }

  loadReminder(reminder_id: number): Promise<Reminder> {
    return this.httpClient.get(`${this.url}/${reminder_id}.json`, { get_reminder: true }).then((response) => response as Reminder);
  }

  save(reminder: Reminder, angular2: boolean = false): Promise<any> {
    return super.save({
      id: reminder.id,
      reminder: reminder,
      angular2: angular2
    });
  }

  snooze(reminder_id: number): Promise<any> {
    return this.httpClient.post(`${this.url}/${reminder_id}/snooze.json`, {});
  }

  updatePosition(positions: Array<number>): Promise<any> {
    return this.httpClient.put(`${this.url}/update_position.json`, { positions: positions });
  }
}
